<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fronttitle ">Translator’s Note</h1>
<p class="left ">In Hebrew, the title of this book is <em>Hesed Sefaradi. Hesed</em> (with a guttural <em>h</em>) eludes precise translation and connotes compassion, kindness, love, and charity; a fair equivalent is the Latin <em>caritas. Sefaradi</em> means “Spanish” but also “Sephardic,” referring specifically to Jews whose ancestors were expelled from Spain in 1492 and more broadly to “Oriental” Jews from Arabic-speaking countries in North Africa and the Middle East. The double meaning helps the reader get the picture.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front02.vue?77d1b69c